import { createAction, props } from '@ngrx/store';
import { FrontendEnvironment } from './environment.model';

const PREFIX = '[Environment] ';

export const loadEnvironmentSuccessAction = createAction(
	PREFIX + 'Load Environment Success',
	props<{
		environment: FrontendEnvironment;
	}>()
);
